export const VID_PRIVACY_NOTICE_URL =
  "https://www.spaxialstrategy.com/privacy.pdf";
export const VID_PRIVACY_EMAIL = "privacy@spaxialstrategy.com";
